module.exports = __webpack_public_path__ + "img/dhl.77b50f3b.png";